import { APP_CONFIG } from '@/config/app.config';

const PREFIX = `${APP_CONFIG.storageNamespace}:${APP_CONFIG.storageVersion}`;

export const STORAGE_KEYS = {
  settings: `${PREFIX}:settings`,
  businesses: `${PREFIX}:businesses`,
  categories: `${PREFIX}:categories`,
  services: `${PREFIX}:services`,
  customers: `${PREFIX}:customers`,
  presets: `${PREFIX}:presets`,
  quotes: `${PREFIX}:quotes`,
  draft: `${PREFIX}:draft`,
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
